export const googleReviews = [
  {
    author: 'dr. Cellica Nurrachadiana',
    role: 'Bupati Karawang',
    rating: 5,
    text: 'Alhamdulillah umroh dengan sanema sangat mengesankan, pelayanannya bagus dan sangat baik. Saya merekomendasikan umroh bersama Sanema Tour & Travel.',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Dilla Erista',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Ini kedua kalinya Teh Dila pakai Sanema Tour, pokoknya sampai Indonesia berat badan nambah karena makan terus. Pelayanannya sungguh sangat luar biasa.',
    keywords: ['pelayanan', 'makanan'],
  },
  {
    author: 'Ustadz Azhari Nasution & Ustadzah Syifa Nurfadhilah',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'umroh bersama Sanema kali ini begitu berkesan, mulai dari handlingnya rapi, direct ke Madinah, makanan Albaik, kereta express, dan bimbingan ibadah yang sangat terfokus.',
    keywords: ['umroh & haji', 'pelayanan', 'city tour'],
  },
  {
    author: 'Aliya Rahma Cinta',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah, di usia 18 tahun aku bisa umroh bareng keluarga. Awalnya sempat khawatir karena bawa adik kecil, tapi ternyata Sanema Tour bener-bener bikin perjalanan jadi nyaman dan tenang. City tour ke Thaif dan belanja di Pasar Kakiyah jadi pengalaman seru yang tak terlupakan. Hotelnya nyaman, makanannya enak, dan pelayanannya luar biasa. Terima kasih Sanema Tour!',
    keywords: ['umroh & haji', 'pengalaman', 'pelayanan'],
  },
  {
    author: 'Imas Masnuriah',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah, meski baru sebulan berlalu, rasa rindu ke tanah suci sudah terasa. Umroh bersama Sanema Tour benar-benar memuaskan—perjalanan lancar, hotel dekat masjid, air Zamzam tersedia di kamar, dan bawa anak pun tetap nyaman. Tour leader dan muthawif juga ramah dan membantu. Makanan selalu tersedia, bikin perjalanan makin menyenangkan. Semoga bisa umroh lagi bareng Sanema Tour.',
    keywords: ['umroh & haji', 'hotel', 'pengalaman', 'makanan'],
  },
  {
    author: 'Sri Mulya Yuani',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Masya Alloh Tabarakallah... Momen paling berharga dalam hidupku. Bisa berangkat Umroh. Difasilitasi Sanema Tour n Travel. Sesuai dengan slogan Umroh Mudah Anti Resah.. Insya Alloh Berkah. Alloh SWT Maha Berkehendak. Alloh SWT mampukan hambaNYA utk berkunjung k Tanah Suci dengan segala Kemudahan.  Semoga suatu saat nanti, Ramadhan tahun depan Insya Alloh Go Baitullah. Aamiin',
    keywords: ['umroh & haji', 'pengalaman'],
  },
  {
    author: 'Ade Pina',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Masya allah tabarakallah, Terimakasih banyak Travel Sanema tour “Umroh Mudah Anti Resah” sesuai dengan slogannya sangat mudah dan anti resah resah disana, fasilitas di handling semua dan Sangat nyaman sekalii.. Allhamdulillah bersama sanema bisa menjadi jalan untuk bertamu dan beribadah kerumah Allah. 03 november -12 november 2024.. Semoga tahun tahun berikutnya bisa allah panggil kembali tentunya dengan travel yang sama @Sanema Tour',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Li Yeni Rohyani',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah, terima kasih Sanema Tour atas pelayanan luar biasa dalam perjalanan umroh kami. Semua dipersiapkan dan difasilitasi dengan sangat baik, dari awal sampai pulang. Terima kasih untuk Pa Dhe yang sabar dan sigap, juga ustadz yang membimbing dengan baik. Jamaah sangat menikmati perjalanan ini. Semoga Sanema makin sukses, jamaahnya makin banyak, dan jadi amal kebaikan untuk seluruh kru. Aamiin.',
    keywords: ['umroh & haji', 'pelayanan', 'city tour'],
  },
  {
    author: 'Jabarudin Winda Permana',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Saya sangat puas dengan layanan Sanema Tour. Semua terorganisir rapi dari awal sampai akhir. Timnya profesional, ramah, dan selalu siap membantu. Transportasi nyaman, jadwal efisien, makanan enak, dan pemandu wisata berpengalaman membuat perjalanan jadi menyenangkan dan berkesan. Sangat direkomendasikan! Terima kasih Sanema Tour, pasti akan pakai lagi di masa depan.',
    keywords: ['umroh & haji', 'pelayanan', 'city tour', 'makanan'],
  },
  {
    author: 'Cucu Sumiati',
    role: 'Pengguna Sanema',
    rating: 5,
    text: "Alhamdulilah bersama Sanema tour saya bisa mencium Ka'bah dan  jg ke makam Rosulullah/Roudhoh.alangkah senang nya.saya sampai ke Tanah suci.Masyaallah Tabarokallah🤲🤲🥰🥰 …",
    keywords: ['umroh & haji', 'city tour'],
  },
  {
    author: 'Mokhamad Tosin',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Mulai dari pendaftaran umroh dikantor pelayanan sangat memuaskan diterima dengan hangat menyambut kita dan  sampai kita pergi selama perjalanan ketika di kota Madinah dan Mekah serta beberapa acara city tour pelayanan nya sangat memuaskan. Mulai dari letak hotel dan pelayanan juga cukup memuaskan juga transportasi kita selama disana cukup baik. Sehingga ingin kembali ke Baitullah bersama Sanema Kembali.',
    keywords: ['umroh & haji', 'pelayanan', 'hotel', 'city tour'],
  },
  {
    author: 'Widiya Pranata',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah. Terima kasih Sanema Tour telah membersamai saya dan isteri melaksanaan ibadah umroh. Pelayanan dari mulai pengurusan administrasi, pendaftaran, pemberangkatan, ketika di Mekah dan Madinah hingga kepulangan ke tanah air dilaksanakan dengan baik, tertib dan ramah., sehingga kami bisa lebih fokus melaksanakan ibadah.',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Nasky Perdana',
    role: 'Pengguna Sanema',
    rating: 5,
    text: "Alhamdulillah pengalaman umroh pertama sangat berkesan dilayani dengan baik oleh sanema tour, hotel dan transportasinya nyaman plus sdh koper handling.. didampingi oleh mutawif yg handal, harga 'worth it' dgn apa yang kita dapat, semoga Sy Dan keluarga bisa kesana lg bareng sanema tour, sukses terus sanema tour..",
    keywords: ['umroh & haji', 'pelayanan', 'hotel', 'pengalaman'],
  },
  {
    author: 'Seno Kastomi',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pengalaman Perjalanan umroh pertama kali bersama sanema tour Alhamdulillah diberikan pelayanan yang sangat berkesan dimulai dari persiapan sampai dengan pelaksanaan dibimbing dengan baik. Fasilitas yang diberikan serta seluruh crew sanema memberikan kenyamanan kepada kami semua sehingga kami sangat fokus melaksanakan ibadah disana.',
    keywords: ['umroh & haji', 'pelayanan', 'pengalaman'],
  },
  {
    author: 'Yuce Kuswandani',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Terimakasih banyak Sanema Tour, sdh memfasilitasi dan membersamai saya beserta suami untuk beribadah umroh.. Terimakasih sdh memberikan pengalaman yang begitu berkesan di hati. Semoga dilain kesempatan dpt bekerja sama dan berangkat bersama sama Sanema Tour',
    keywords: ['umroh & haji', 'pengalaman'],
  },
  {
    author: 'Alfaqih JR',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah.. masyaallah terimakasih sanema tour pelyanannya sangat bagus, tour leadernya ramah dan peduli kpd jamaah apalagi jamaah yg sudah sepuh seperti ibu saya. Mutowifnya keren, sangat berpengalaman dalam menjelaskan sejarah2 sangat mudah dipahami.. Terimakasih semua team sanema tour sdh mengizinkan saya mendampingi ibu saya selama di mekah dan madinah..Th cindy, bunda ida, a rizal, th suci, th fella.. semuanya pokoknya terimakasih banyak😘',
    keywords: ['umroh & haji', 'pelayanan', 'city tour'],
  },
  {
    author: 'Yuni Widya Andriningsih',
    role: 'Pengguna Sanema',
    rating: 5,
    text: "Sesuai slogannya, 'Umroh Mudah Anti Resah', pengalaman umroh bersama Sanema Tour memang mudah dan nyaman. Semua urusan—dari keberangkatan, ibadah, hingga pulang—diurus dengan baik. Hotel dekat masjid, kamar dapat air Zamzam dan buah, tim TL dan mutawwif ramah dan profesional. Masuk Raudhah juga dibantu maksimal. Sanema adalah travel resmi dengan akreditasi A, jadi sangat aman dan terpercaya. Recommended banget!",
    keywords: ['umroh & haji', 'pengalaman', 'hotel', 'pelayanan'],
  },
  {
    author: 'Astuti Soetoro',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah, satu keberkahan dapat mewujudkan harapan dan cita-cita dengan menjalankan umroh bersama emak tercinta melalui Sanema Tour n Travel.  The excellent service yang luar biasa dapat kami rasakan, baik dari  team panitia pelaksana, team Leader, Muthawif dari awal keberangkatan hingga kepulangan ke tanah air. Sesuai dengan slogan Umroh mudah, anti resah! Jazaakumullah khairan katsiro, semoga semakin sukses ke depannya. Terus pertahankan kualitas pelayanan yang sudah optimal, menjadi biro travel terdepan di Karawang khususnya hingga di Indonesia bahkan manca negara. Barakallahu Fiikum..',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Dwi Ayu Rahmawati',
    role: 'Pengguna Sanema',
    rating: 4,
    text: 'Umroh pake travel ini ga nyesel sih, recomended bgtt… selain fasilitasnya yg berkualitas, pelayanan nya jg ramah sekali, tour leader nya humble bgt dan care ke semua jamaah, muthawif nya yg kompeten jadi setiap tempat yg kita datangi dan yg dilewati selalu diberikan penjelasan sejarah nya lengkap sekali dan mudah dimengerti oleh jamaah… anti laper, ibadah nyaman, betah bgt pokoknya, insha allah nanti klo berangkat umroh lagi pake travel Sanema Tour lagi👍🏻✨✨✨',
    keywords: ['umroh & haji', 'pelayanan', 'city tour'],
  },
  {
    author: 'Endangsundari Doadi',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Doorprize umroh di acara hari kesehatan nasional yg diselenggarakan oleh dinkes kab karawang, pada tgl 30 maret 2024, Menjadi awal perkenalan dgn travel sanema, Alhamdulillah ,, perjalanan umroh dgn travel sanema, sangat berkesan, karena hotel tempat menginap selama di madinah & mekkah,  adalah hotel yg paling dekat dgn harom , sehingga menjadikan ibadah saya menjadi lebih mudah dan lancar , Terimakasih sanema , sukses terus,  semoga berkah dunia akhirat ... Aamiiin',
    keywords: ['umroh & haji', 'pengalaman', 'hotel'],
  },
  {
    author: 'Deane G',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Seru banget umroh dgn Sanema tour, lancar dr berangkat sampai pulang. Bu suci terima kasih banyak',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Dwi Laksono',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sanema memang keren. Alhamdulillah kami bisa melaksanakan umroh keberangkatan 26 oktober 2024 kemarin dengan riang gembira.  Muthawif dan TL nya sabar membimbing kami, dan beneran gak ribet. Semua sudah disiapkan dengan rapi.',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Hans Haryanto',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Bismillah.... Alhamdulillah.. Kami ber4 .. saya (Kudus) mertua (Demak) dan adik ipar sekalian (Cikarang). Kami merasa puas dengan pejalan dan proses umproh bersama sanema tour.. Yg telah membimbing kami dgn kompak kerjasama antara tour leader dan mutoif... Kami merasa mudah dan dimudahkan dlm ibadah. Semoga sanema tour yg sudah baik semakin baik... Salam satu iman ... Salam🖐️',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Een Nuraenah',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Masya Allah, alhamdulillah Umroh Ibu berjalan lancar bersama Sanema Tour. Awalnya ragu berangkat sendiri, tapi berkat pelayanan yang ramah dan profesional dari customer service, staf, hingga muthawif, semuanya jadi terasa nyaman. Semoga ada rezeki bisa umroh lagi bareng anak-anak lewat Sanema Tour. Barakallah dan berkah untuk kita semua',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Darsono Mentri',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah 24 Des 24 kemarin kami berangkat umroh bersama rombongan dgn Sanema Tour. Benar2 terasa customer satisfaction kami rasakan semua pelayanannya. Semua pegawainya sangat antusias dan sangat ramah  sekali. Semoga suatu saat kami bisa umroh lagi dgn Sanema Tour yg kami banggakan. See you.',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Aris Tio',
    role: 'Pengguna Sanema',
    rating: 5,
    text: "Alhamdulillah dengan sanema tour, perjalanan umroh kami lebih nyaman, semua dari awal brangkat sampai plg ke tanah air semua sudah ada yg handle, begitu juga dengan tour leader dan muthawifnya yang humoris dan ramah membimbing dang melayani jama'ah nya. Pokoknya IS THE BEST Utk Sanema tour.",
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Rustiwan 84',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Subhanallah memang Sanema Tour and Travel terbaik dalam pelayanan prima kepada jamaahnya dari mulai manasik, perlengkapan, pelayanan keberangkatan, tour leader, mutowif dan pelayanan kepulangan. Sanema Tour and Travel tambah Sukses dan maju',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Yudhia Dwi Amrina',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sanema Tour benar-benar travel umroh terbaik! Pelayanannya luar biasa, mulai dari manasik di hotel bintang 5, akomodasi dari Karawang ke bandara, hingga pakai maskapai top seperti Qatar Airways langsung ke Madinah. Hotelnya dekat masjid, ada bonus ziarah Thaif dan Teletrif, plus nasi mandhi. Tour leader dan mutawwif sangat profesional—lulusan Universitas Madinah dan Syria. Semua ibadah sesuai sunnah, jadwal tepat waktu, dan stafnya ramah. Sukses terus Sanema Tour!',
    keywords: ['umroh & haji', 'pelayanan', 'hotel', 'city tour'],
  },
  {
    author: 'Yudi Ciamis',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sanema tour emang top, pelayanan baik dan memuaskan. Ada team dokumentasi jadi tak perlu repot2 pegang hp',
    keywords: ['pelayanan'],
  },
  {
    author: 'Haris Fadhilah',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Luar biasa di akomodir oleh Travel Sanema pokoknya komplit pengalaman umrohnya',
    keywords: ['umroh & haji', 'pengalaman'],
  },
  {
    author: 'Heri Herdiana',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Ma sya Allah.. Terimakasih keluarga Sanema Tour..atas  semuanya,bnar2 sangat memuaskan..',
    keywords: ['umroh & haji', 'pelayanan', 'hotel', 'makanan', 'city tour'],
  },
  {
    author: 'Nurwahida Yakub',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah, kami pulang dengan selamat. Terima kasih Sanema Tour atas pelayanan terbaiknya. Crew, mutowwif, dan tour leader sangat ramah dan berpengalaman, membuat perjalanan penuh makna. Armada bus nyaman, hotel dekat masjid, koper pun langsung diantar ke kamar. Pelayanan seperti ini patut dipertahankan. Kalau bingung cari travel umroh, Sanema Tour aja — Umroh Mudah Anti Resah!',
    keywords: ['umroh & haji', 'pelayanan', 'hotel'],
  },
  {
    author: 'Ati Kusmiati',
    role: 'Pengguna Sanema',
    rating: 5,
    text: "Alhamdulillah yaa Allah telah memanggil kami untuk menjadi tamu Mu dengan difasilitasi Sanema Tour yang memberikan kenyamanan dan kemudahan dlm beribadah di Tanah Suci. UMROH MUDAH ANTI RESAH, benar adanya.. Terima kasih Sanema. S'moga semakin baik n baik lgi pelayanannya. Barokallohu fiikum.",
    keywords: ['umroh & haji', 'pengalaman', 'pelayanan'],
  },
  {
    author: 'Sri Hartini Aditya',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Masyaallah tabarakallah ibu sama bapak aku puas banget menjalankan ibadah umroh bersama sanema tour and travel, umroh mudah anti resah🥰🥰 …',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Ari Hardiyanto',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Umroh bareng sanema sangat keren.. Alhamdulillah semua diberikan kemudahan dan kelancaran sehingga kami ber5 bisa umroh keluarga... Barokallah fiikum... Sukses terus sanema tour',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Nisa Ikatiana',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah, umroh bersama Sanema sangat nyaman, tenang, dan menyenangkan. Prosesnya lancar dari awal sampai akhir, koper langsung sampai depan kamar. Hotel dekat masjid dan fasilitasnya bagus. Admin cepat tanggap dan ramah. Tour Leader dan Muthawif sangat membantu dan komunikatif. Pelayanannya top banget! Terima kasih dan sukses selalu untuk Sanema Tour.',
    keywords: ['umroh & haji', 'pelayanan', 'pengalaman'],
  },
  {
    author: 'Adum Doank',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah saat ada rencana Umroh sekeluarga, setelah membandingkan 3 informasi yg didapat. Dan saya putusin pakai Sanematour dan pilihan saya tepat. Karena Umroh bersama Sanematour benar-benar puas, no ribet, no was was, judule puaaas poool. Termasuk anak ketiga ku sikecil benar-benar happy',
    keywords: ['umroh & haji', 'pengalaman'],
  },
  {
    author: 'Imun Munawaroh',
    role: 'Pengguna Sanema',
    rating: 4,
    text: 'Alhamdulillah tour leadernya keren melayani dengan sepenuh hati,',
    keywords: ['pelayanan'],
  },
  {
    author: 'Dody Sukma Tirtana',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sangat puas, dari mulai paket umrohnya, fasilitas, pelayanannya luar biasa,,',
    keywords: ['umroh & haji', 'pelayanan', 'hotel', 'makanan'],
  },
  {
    author: 'Wike Komatsu',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Perjalanan umroh yang sangat penuh makna,pelayanan supper  dupper nyaman, tour leader dan mutowiif  sangat mudah di pahami dalam membimbing saya .Recommend banget Sanema Tour ... terima kasih sudah menemani perjalanan umroh kami. Terima kasih kpd  Allah SWT yang  telah mempertemukan saya dengan Sanema dan  angkatan umroh kami .Smoga kita tetap  bisa menjaga silaturahmi dan dipertemukan diumroh selanjutnya. Aamiin ya Robbal allamin.',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Ate Amar',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sanema tour sangat aman dn nyaman dlm pelayanan ibadah,perjlnn ,hotel,city tour,respon gercep,sehingga kita bisa fokus beribadah,dokumentasi lngkp,ramah muthawif,ibadah mudah anti resah Sanema makin sukses jaya',
    keywords: ['umroh & haji', 'pelayanan', 'city tour', 'hotel'],
  },
  {
    author: 'Husen Fadil',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah, Sanema Tour adalah Perusahaan Travel Haji dan Umroh terbaik menurut saya. Pengalaman yang sangat baik dan nyaman serta pelayanan yang maksimal yang saya rasakan dan sangat rekom sekali.',
    keywords: ['umroh & haji', 'pengalaman', 'pelayanan'],
  },
  {
    author: 'Nuraeni Mulyati',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Trimaksih buat Sanema tour yg tlh memfasilitasi kmi buat prjlnan umrohnya,sehingga rukun umrohnya terpenuhi,trimksih ats bimbingannya,trimaksih ats perhtiannya,mohn maaf apbl kmi ada slah2',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Idoel Clothing',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Awalnya sempat kecewa karena dapat kamar terpisah dan hotel terlihat kurang nyaman. Bahkan saat buka puasa di hotel sebelah pun suasananya terlalu ramai. Tapi saat sahur di hotel sendiri, ternyata nyaman, tenang, makanannya enak dan cocok di lidah. Sanema sempat menawarkan pindah hotel, tapi kami menolak karena sudah merasa nyaman. Dari sini saya belajar, jangan menilai dari tampilan luar saja. Terima kasih banyak untuk Sanema Tour.',
    keywords: ['umroh & haji', 'makanan', 'hotel'],
  },
  {
    author: 'Surya Mardani',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Umroh dengan sanema sangat memuaskan. semua staf sangat ramah dan sangat membantu, mulai proses pendaftaran, berangkat sampai kembali lagi ke indonesia. fasilitas selama di mekah dan madinah juga bagus, mutowif dan tim leadernya sangat baik dan berpengalaman. semua kekeluargaan. jadi serasa umroh bareng dengan keluarga besar. insya allah kalau ada rejeki pengen umroh lagi dengan sanema.',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Cindy Patikasari',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah,trevel umroh bersama Sanema Tour perjalanan yg sangat memuaskan untuk ke Baitulloh pokok nya the bast memakai jasanya semoga saya bisa kembali ke baitulloh bersama sanema tour 😍 …',
    keywords: ['umroh & haji', 'pengalaman'],
  },
  {
    author: 'Nizar & Ayyash',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sanema tour travel terbaik maa syaa Alloh..pelayanan dari keberangkatan sampai kepulangan dilayani dengan sepenuh hati.Tour leader dan Muthowwif nya the best sat set dalam melayani jamaah. Semoga sanema tour makin sukses makin banyak yang ke Baitullah bersama sanema tour. Aamiin Mau umroh? Inget sanematour Sanema tour go Baitullah',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Ahmad Fauzi',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Berdasarkan pengalaman saya waktu umroh menggunakan jasa travel sanema tour sungguh sangat mengesankan baik dari sebelum keberangkatan dan kepulangan ke tanah air di layani dengan keramah tamahan dan kekeluargaan, petugas bekerja dengan profesional dan dedikasi tinggi, pokoknya puas dan recommended',
    keywords: ['umroh & haji', 'pengalaman', 'pelayanan'],
  },
  {
    author: 'Rima Firmansyah',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Siapa yang mendahulukan niat ke Baitullah, Insya Allah dimudahkan. Kami pun merasakannya saat memilih Sanema Tour. Pelayanannya ramah dan luar biasa, dari persiapan hingga pulang ke tanah air. Fasilitas sesuai harapan, dan bimbingan Tour Leader serta Muthawif mengikuti sunnah. Pokoknya, Sanema Tour — Umroh Mudah Anti Resah! Terima kasih, jazakumullah khairan.',
    keywords: ['umroh & haji', 'pelayanan', 'hotel', 'makanan'],
  },
  {
    author: 'Trisa Warnida',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah, Sanema Tour benar-benar travel umroh yang amanah. Hotelnya sangat dekat dengan Masjid Nabawi dan Masjidil Haram. Pelayanan top, mulai dari bus, snack, nasi box, hingga makanan hotel—semuanya enak. Tour leader bertanggung jawab, mutawif jelas dalam membimbing, dan tim handling luar biasa. Semua diurus, jadi kami bisa fokus ibadah. Saya dan suami sangat puas, tidak ada penyesalan. Terima kasih Sanema Tour, sukses selalu!',
    keywords: ['umroh & haji', 'pelayanan', 'hotel', 'makanan'],
  },
  {
    author: 'Rostiana Ristam',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Bergabung di sabema dari thn 2017,,,masyallah,,,pelayanan yg sangat maximal dari pendaftaran,,pasporan ,keberangkatan ,,di tanah suci hingga kembali ke tanah air Etenary dan roundown acaranya jelas,,,mengusung konsep 5P pasti travelnya,pasti pesawatnya pasti brgktnya dll,,, Dan saya merekomendasikan kpd semua teman dan handai tolan utk umroh atau haji bersama sanematour&travel Go baitullah bersama sanematour&travel Yes,,,,,travel yg amanah',
    keywords: ['umroh & haji', 'pelayanan', 'pengalaman'],
  },
  {
    author: 'Andi Prasetio',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Travel yang diisi oleh anak2 muda, inspiratif dan sangat cocok jadi referensi. Alhamdulillah berangkat umroh bareng istri dan teman2 baru. Sukses dan maju terus Sanema Tour',
    keywords: ['umroh & haji'],
  },
  {
    author: 'Novia Laparoskopi',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'MasyaAllah ingin mengulang kembali umroh brg sanema , firsttime umroh brg sanema membawa kesan yg puas karena sanema memberikan pelayanan terbaik, ❤️ masyaAllah sukses trs sanema',
    keywords: ['umroh & haji', 'pengalaman', 'pelayanan'],
  },
  {
    author: 'Rahmawati Dzaelani',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Travel terbaik, semoga makin sukses, berkah berlimpah jamaahnya dan semoga saya bisa bawa keluarga besar saya umroh dan haji bersama SANEMA, Aamiin',
    keywords: ['umroh & haji'],
  },
  {
    author: 'Kaos Cikarang',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Nilainya 9.9 dari 10. Karena kesempurnaan hanya milik Alloh... udh cukup yakin kasih rekomendasi 2 jempol buat rekan2 yg ingin melakukan perjalnan umroh',
    keywords: ['umroh & haji', 'pelayanan', 'makanan', 'hotel', 'city tour'],
  },
  {
    author: 'Muhamad Jili',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pelayanan crew maksimal, muthowif terbaik, makan sangat tercukupi, umroh bareng sanema anti resah dan anti lapar 😂 …',
    keywords: ['umroh & haji', 'pelayanan', 'makanan'],
  },
  {
    author: 'Ismulloh Ismu',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pengalaman pertama umroh, istri berangkat sendiri, dengan testimoni sangat puas. Dan kita lanjutkan dengan keberangkatan berdua, tanggal 10 September 2024, Alhamdulillah..',
    keywords: [
      'umroh & haji',
      'pengalaman',
      'pelayanan',
      'hotel',
      'makanan',
      'city tour',
    ],
  },
  {
    author: 'Gina Anggraeni',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Umroh klrg bersama Sanema, pelayanan bagus, pendaftaran cepat mudah dan ga ribet. Staf2  dan pembimbing ramah2. Pokok y mau umroh, bareng Sanema aj🥰 …',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Manda Sejahtera',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pengalaman yang sangat berkesan dan sangat menenangkan Bersama Sanema Tour ibadah umroh sangat nyaman.. bersama ustad pembimbing dan Mutowif yang sangat sabar memberikan idukasi saran2 dan amalan2 yang membuat tambah hikmah ibadah kita.. Semoga Sanema Tour lebih maju dan slalu amanah.. Amiiin ya robal alamin..',
    keywords: ['umroh & haji', 'pelayanan', 'pengalaman'],
  },
  {
    author: 'Teguh PR',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Rekomendasi travel umroh di karawang dengan berbagai pilihan paket umroh... Pelayanan terbaik dan respon CS yang cepat...',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'NS Motor',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pengalaman umroh bersama Sanema di bulan Januari 2025 sangat memuaskan',
    keywords: [
      'umroh & haji',
      'pengalaman',
      'hotel',
      'makanan',
      'city tour',
      'pelayanan',
    ],
  },
  {
    author: 'Gurubahagia 168',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Wow, senang banget bisa umroh bareng Sanema Tour! Ibadah berjalan lancar dan tenang karena pelayanannya keren dan terbuka pada masukan. Programnya seru, cerita perjalanannya menarik dari awal sampai pulang ke Tangerang. Saya puas banget, semoga ke depannya bisa umroh atau haji lagi bersama Sanema. Sukses terus Sanema Tour! – Ali Syafaat, Tangerang.',
    keywords: ['umroh & haji', 'pelayanan', 'city tour'],
  },
  {
    author: 'Eutik Nurhayati',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah perjalan umroh bersama Sanema tour-travel membuat kami tenang dan senang mendapatkan pembimbingan yang maksimal serta kekompakan sesama teman seperjuangan semua menjadi satu keluarga saling menolong, semoga Sanema terus maju dan amanah menjembatani para tamu Allah.',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Asep Eman',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Saya mengucapakan terimakasih sekali kepada Travel Sanema Tour yang telah membantu dalam pelaksanaan Umroh dengan pelayanan sangat memuaskan mulai dari proses daftar, manasik, keberangkatan, berada di Madinah (terutama ketika berada di Raudoh bisa shalat Asar) berada di Mekkah dan Kepulangan dengan selamat sentosa',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Lukman Sani',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Perjalanan umroh yg sangat kami nantikan, dan mendapatkan pelayanan yang sangat memuaskan. Terimakasih tak terhingga kepada Sanema Tour beserta crewnya yg telah memberi kami perjalanan ibadah umroh yg sangat mengesankan dan tak mungkin terlupakan dalam hidup kami.',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Dede Indra Lesmana',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'terimakasih sanema tour telah memfasilitasi ibadah umroh saya, pokoknya sangat puas dengan pelayanan sanema tour ! bintang 5 deh pokoknya',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Chety NC',
    role: 'Pengguna Sanema',
    rating: 4,
    text: 'Fasilitas alhamdulillah tidak mengecewakan , tp dapet muthowif nya kurang profesional krn mendahulukan kepentingan pribadi kebetulan rombongan brgkt bareng bersama istri dan mertuanya bp muthowif terkesan ky hanimun dan umroh pribadi aja tuh bp muthowif, ditambah mertua dan istrinya tidak paham klo beliau lg kerja, Umroh pertama dibimbing TL , bp muthowif nya nenteng tas istri dan banyak lg hal hal diluar nurul. Semoga bisa lebih bijak lg memilih muthowif unk para jamaah . Terimakasih',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Chety NC',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah pengalaman pertama umroh dengan travel sanema yg menyenangkan, memberikan ketenangan dan kenyamanan sehingga saya beserta istri bisa fokus untuk ibadah, memaksimalkan waktu untuk mendekatkan diri pada Allah SWT.... terimakasih sanema tour and travel, tingkatkan terus pelayanan',
    keywords: ['umroh & haji', 'pelayanan', 'pengalaman'],
  },
  {
    author: 'Amey Sasu 1717',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'SANEMA TOUR,,is the Best.. Alhamdulillah sudah dipertemukan dgn sanema tour,yg pelayanan umrohnya sangat memuaskan dari semua pasilitas dari awal sampai akhir,dan bimbingan dari para ustad nya,sangat menggembirakan buat saya,dan ibadahnya pun sangat bisa di ikuti dgn baik 🙏🙏🙏🥰🥰🥰 …',
    keywords: ['umroh & haji', 'pelayanan', 'pengalaman'],
  },
  {
    author: 'Mama Jua',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Masyaalloh bgt pake sanema tour... Waktu itu rombongan kita jamaah 6 mei 23 dpt bonus upgrade hotel euyy.. yg tadinya bintang 3 jadi bintang 5... trmksh byk utk perjalanan spiritual yg memuaskan bersama sanema 🤩 …',
    keywords: ['umroh & haji', 'pengalaman', 'hotel'],
  },
  {
    author: 'Dedi Setiawan',
    role: 'Pengguna Sanema',
    rating: 4,
    text: 'Cukup fokuskan diri untuk kesehatan dan ibadah, sisa nya biar Sanema yang Atur. Alhamdulillah 👍 ⭐️⭐️⭐️⭐️ …',
    keywords: ['umroh & haji', 'pelayanan', 'hotel', 'city tour', 'makanan'],
  },
  {
    author: 'Kartika Dewi',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sanema travel ter the best di Karawang, senang bisa umroh bersama sanema 🥰 …',
    keywords: ['umroh & haji', 'pelayanan', 'hotel', 'city tour', 'makanan'],
  },
  {
    author: 'Betharlitha Maharlika',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah saya dan keluarga puas dengan pelayanan yang diberikan sanema. Dari mulai manasik sampai pelaksanaan umroh, pelayanannya sangat baik. Semoga Allah memberikan kami kesempatan untuk ke Baitullah lagi 🤲 …',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Le Dindin',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sanema tour & travel terbaik dalam segala pelayanan. Sangat memuaskan baik administrasi, pelaksanan, bimbingan, transportasi dan konsumsi..alhamdulillah..terima kasih sanema tour..',
    keywords: ['umroh & haji', 'pelayanan', 'makanan'],
  },
  {
    author: 'R-Come',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Travel terpercaya dan oleh2 haji  umroh terlengkap... Solusi Ibadah Mudah dan berkah, berdagang dengan untung melimpah...',
    keywords: ['umroh & haji'],
  },
  {
    author: 'Karisma Putri',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sanema tour pelayanannya best sekalii',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Prinz Bow',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah...saya percayakan perjalanan ibadah keluarga saya, bersama Sanematour dari tahun 2017 hingga sekarang ini sampai saudara,teman,tetangga Alhamdulillah sangat memuaskan kami semua,dari mulai daftar hingga berangkat selalu di dampingi,di urus semuanya.Pokoknya pake sanema anti ribet,anti resaaah yg pasti pasti aja....pokoknya bikin nagiiih pingin lagi & lagi....',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Dede Mulyana',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah bisa umroh bareng sanema, layanannya super nyaman banget, karena petugas2nya siaga terus, full service banget pokoknya, recommend travel umroooh. Banyaaak promonya pula, cusss',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Nadia Mela Kurnia',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pelayanannya bagus, apa yang dijanjikan sesuai dengan apa yang diberikan, hotelnya walau bintang 3, itu dekat bangetsz sma tempat ibadah... Pokoknya the best deh Sanematour 😍😍 …',
    keywords: ['umroh & haji', 'pelayanan', 'hotel'],
  },
  {
    author: 'Purnomo',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Fasilitas hotel dekat dengan masjid baik di Makkah/Madinah',
    keywords: ['umroh & haji', 'hotel'],
  },
  {
    author: 'Peni Iriani Saputri',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Masya Allah, brgktin org tua pake travel ini, jauh jauh dr Bogor k krwg. Tp bener bener rekomen sesuai ulasan, berkah sukses trus untuk sanema travel, mdh mdhan bs nyusul ibadah pake sanema jg aamiin',
    keywords: ['umroh & haji', 'pengalaman'],
  },
  {
    author: 'Tarwiyati Rosyid',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pelayanan maksimal ,jadi kita bisa aman dan nyaman fokus beribadah...sanema tour n travel is the best🥰 …',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Agus Nanang',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sanema Tour memberikan pelayanan terbaik buat jamaah, bahkan dengan keluarga Jamaah',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Linda Purnama Dewi',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Ingin lagi dan lagi berangkat umroh dgn sanema🥰 …',
    keywords: ['umroh & haji'],
  },
  {
    author: 'Agus Suryana',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pelayanan sangat bagus insyaallah kalau ada rezeki daftar lg sama keluarga ke sinema',
    keywords: ['pelayanan', 'world tour'],
  },
  {
    author: 'Angga Yusman',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '👍 …',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Ria Oktavika',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Memuaskan',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Ahmad Blankwar',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah, Sanema Tour Bagus Sekali',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Dardjo Untoro',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah...pelayanan prima',
    keywords: ['pelayanan', 'world tour'],
  },
  {
    author: 'Ilma Hadianti',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sangat recommended👍 …',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Masuk TV',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pelayanan sangat bagus, pokoknya recommended banget deh travel yang satu ini',
    keywords: ['pelayanan', 'world tour'],
  },
  {
    author: 'Weni Setyo',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Terbaik....... 🥰🥰🥰🥰 …',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Caramel Macchiato',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pelayanannya sangat baik, terima kasih Sanema',
    keywords: ['pelayanan', 'world tour'],
  },
  {
    author: 'Roxy',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Travel Top Karawang',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Ifa Marlita Shari',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pelayanannya luar biasa memuaskan.',
    keywords: ['pelayanan', 'world tour'],
  },
  {
    author: 'Muhammad Iqbal',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'TL dan muthowifnya profesional..👍👍 …',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Jeppi Anggara',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Travel & umroh terpercaya',
    keywords: ['umroh & haji', 'pelayanan', 'hotel', 'makanan'],
  },
  {
    author: 'Weli Nug',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Sanema tour...mantap...',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Nurhadi Rohman',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Ibadah jadi mudah dgn sanema',
    keywords: ['umroh & haji', 'pelayanan'],
  },
  {
    author: 'Apip Fudoli SF',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Subhanallah betah',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Riswandi Cinematrophy',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Travel terbaik dan terpercaya - Turkey',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Kurma Karawang',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Terbaik dan terpercaya',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Ucep Nurman',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Dari - sampai tujuan',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Mufida Salsabila',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Alhamdulillah sudah 2 kali SANEMA TOUR membantu keluarga kami mewujudkan cita cita kami untuk berangkat ke baitullah, pertama tahun lalu orang tua kami yang diberangkatkan dan kali ini kami berdua yang menjadi tamu Allah, semoga SANEMA TOUR tetap menjadi wadah yang baik untuk insan insan yang bercita cita menjadi Tamu Allah, terima kasih SANEMA TOUR. SANEMA TOUR...GO BAITULLAH SANEMA TOUR ...UMROH MUDAH ANTI RESAH...',
    keywords: ['umroh & haji', 'pengalaman', 'pelayanan'],
  },
  {
    author: 'Citra Octapian',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Terima kasih untuk perjalanan umroh yang luar biasa. Saya memiliki momen berharga di Madinah & Makkah dan waktu tak terlupakan menjelajahi tempat-tempat baru. Tur Sanema menjadikan pengalaman itu lebih istimewa. Umroh Plus Thaif adalah pilihan yang bagus, Terima kasih untuk Ketua Tim (Kang Ilyas & Bu Rahma), Muttawif (Ust. Tursi) atas bantuannya yang sangat membantu selama perjalanan. Jangan khawatir tentang layanan makanan. Semuanya enak dan enak 🤣👍👍',
    keywords: [
      'umroh & haji',
      'pelayanan',
      'makanan',
      'pengalaman',
      'city tour',
      'hotel',
    ],
  },
  {
    author: 'Lenny S.Rahayu',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Pengalaman terbaik yang pernah saya alami untuk umroh pertama saya. Terima kasih Sanema atas pelayanan dan fasilitas terbaiknya. Pemimpin tur, staf, dan mutawwif yang sangat baik dan membantu jemaah. Sanema juga bersertifikat ISO 9001, kualitasnya tidak diragukan lagi.',
    keywords: ['umroh & haji', 'pengalaman', 'pelayanan', 'hotel', 'makanan'],
  },
  {
    author: 'Hendrik Soni',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Terbaik 👍 …',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Muhamad Yogi Ginanjar',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Hani Nurul',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Nandang Sunandar',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Ridwan Visioner',
    role: 'Pengguna Sanema',
    rating: 5,
    text: 'Perjalanan Teratas',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Muhammad Aldi Kurniawan',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Wiwin Roswianti',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Nani Mulyani',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Hari Yanto',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'M. Zainal Alim',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Aa Suwardi',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Rusyandi Yan',
    role: 'Pengguna Sanema',
    rating: 4,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Ajat Burhanudin Chanel',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Putra-Putri Hartono',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Santi Damayanti',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Fadli Dwisandy Limbat',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Riska Andriyani',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Neneng Supriatin',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Yoka 17',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Endang Komarudin',
    role: 'Pengguna Sanema',
    rating: 4,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Mang Channel',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'N Afriani Hidayati',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Karriz ID',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Amon Erwin Talaksoru',
    role: 'Pengguna Sanema',
    rating: 4,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Ilyaz Fauzi',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Priyo Utomo R',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Wiwin Azka',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Deden Badrudin',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Agih Raharjo',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'As Boris (Boris sgm tea)',
    role: 'Pengguna Sanema',
    rating: 4,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Imron Sigit Rachman',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Elvina IndraDiva',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Widahyano Ganteng',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Jeni Siswo',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Gissel Lagi',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
  {
    author: 'Sepri Hermawan',
    role: 'Pengguna Sanema',
    rating: 5,
    text: '',
    keywords: ['pelayanan', 'hotel', 'makanan', 'city tour', 'world tour'],
  },
];
